import { Modalable, ResponseStatus } from './modalable';
import { QuickLinkSignFormData } from './quick-link-sign-form-data';

export class ModalableYedo implements Modalable {
    static MODAL_ID = 'yedoSignModal';
    bypass = true;
    formData: QuickLinkSignFormData;
    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getFormData(): QuickLinkSignFormData {
        return this.formData;
    }

    getModalId(): string {
        return ModalableYedo.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypass;
    }
}
